export default __webpack_public_path__ + "static/hindidiwas-03909e57d3fdfe19f61a38da51af114b.pdf";